export default {"src":"/_next/static/media/home_bold.69e45841.svg","height":24,"width":24};